import React from "react";
import pkg from "../../package.json";

const DompetVersion = () => {
  return (
    <div className="text-center text-xs text-monochrome-400">
      <p>v{pkg.version}</p>
    </div>
  );
};

export default DompetVersion;
